export default {
  path: process.env.VUE_APP_IMAGE_URL
};
